import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=711dbd7b&scoped=true&"
import script from "./SignaturePad.vue?vue&type=script&lang=js&"
export * from "./SignaturePad.vue?vue&type=script&lang=js&"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=711dbd7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711dbd7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VIcon,VResponsive})
